/**
 * Canonical URL builder for any package-shaped object.
 *
 * Why this exists:
 *   Homepage Featured/Trending rails and the Trending-Now mixed feed used
 *   to hardcode `/packages/<slug>` for every item — including Group
 *   Departure packages, which actually live under `/group-travel/<slug>`.
 *   This helper centralises the route decision so we never duplicate the
 *   `is-this-a-group-trip?` check inline again.
 *
 * Discriminator tolerance:
 *   - `pkg.package_type === 'group'`   ← canonical backend field
 *     (emitted by /api/packages/featured, /api/packages/trending,
 *     /api/cms/trending-now).
 *   - `pkg.type === 'group'`           ← client-synthesised field
 *     (DestinationDetail.jsx tags the two collections it fetches
 *     separately at lines 221-222).
 *   - `pkg.isGroup === true`           ← admin-side boolean used by
 *     CMSPackages.jsx.
 *
 * Slug fallback order: `slug` → `id` → empty path (defensive — caller
 * should never render a card without one of these, but we avoid emitting
 * a broken `/packages/undefined` URL).
 */
export const isGroupPackage = (pkg) => {
  if (!pkg) return false;
  return (
    pkg.package_type === 'group' ||
    pkg.type === 'group' ||
    pkg.isGroup === true
  );
};

export const getPackageUrl = (pkg) => {
  if (!pkg) return '/packages';
  const slug = pkg.slug || pkg.id || '';
  return isGroupPackage(pkg)
    ? `/group-travel/${slug}`
    : `/packages/${slug}`;
};

export default getPackageUrl;
